import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { businessInfo } from '../mock';

export const Footer = () => {
  return (
    <footer className="bg-black text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and tagline */}
          <div className="col-span-1 md:col-span-2">
            <img 
              src={businessInfo.logoUrl} 
              alt={businessInfo.name}
              className="h-16 w-auto mb-4"
            />
            <p className="text-gray-300 mb-4 leading-relaxed">
              {businessInfo.tagline}
            </p>
            <p className="text-sm text-gray-400">
              {businessInfo.qualification} serving the Inverclyde area with professional driving instruction.
            </p>
          </div>
          
          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-red-500">Contact</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-red-500" />
                <span className="text-gray-300">{businessInfo.phone}</span>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-red-500" />
                <span className="text-gray-300">{businessInfo.email}</span>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-red-500 mt-1" />
                <div className="text-gray-300">
                  {businessInfo.coverageAreas.join(', ')}
                </div>
              </div>
            </div>
          </div>
          
          {/* Operating Hours */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-red-500">Hours</h3>
            <div className="space-y-2 text-gray-300">
              <div className="flex items-center space-x-3">
                <Clock className="w-5 h-5 text-red-500" />
                <span>Flexible scheduling</span>
              </div>
              <div className="text-sm text-gray-400">
                <p>Monday - Sunday</p>
                <p>Morning & Evening slots available</p>
                <p>Contact for availability</p>
              </div>
            </div>
          </div>
        </div>
        
        {/* Bottom bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © 2025 {businessInfo.name}. All rights reserved.
            </p>
            <div className="flex flex-wrap items-center justify-center md:justify-end gap-4 text-sm text-gray-400">
              <span>DVSA Approved Instructor</span>
              <span>Fully ICO Compliant</span>
              <span>Automatic Transmission</span>
              <span>Local Area Coverage</span>
              <Link to="/terms" className="hover:text-red-500 transition-colors">
                Terms & Conditions
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;